import { ACTION_TYPE } from '../../../store/actionCreatorsHelpers';

interface Filters {
    [key: string]: boolean;
}

export function searchChange(query: string) {
    return {
        type: ACTION_TYPE.SEARCH_CHANGE,
        query,
    };
}
export function requestTrigger() {
    return {
        type: ACTION_TYPE.REFRESH_APPS_FILTER,
    };
}
export function updateFilter(filterGroup: string, filterName: string, value: boolean) {
    return {
        type: ACTION_TYPE.UPDATE_APPS_FILTER,
        filterGroup,
        filter: {
            [filterName]: value,
        },
    };
}
export function replaceFilter(filterGroup: string, filters: Filters) {
    return {
        type: ACTION_TYPE.REPLACE_APPS_FILTER,
        filterGroup,
        filter: filters,
    };
}
export function resetFilters() {
    return {
        type: ACTION_TYPE.RESET_APPS_FILTERS,
    };
}
export function toggleFilters() {
    return {
        type: ACTION_TYPE.TOGGLE_APPS_FILTERS,
    };
}
export function selectNew() {
    return {
        type: ACTION_TYPE.SELECT_NEW_FILTER,
    };
}
